module.exports = __webpack_public_path__ + "static/media/directcc_1002.632623ef.ico";